// src/components/personal/sections/ClientsSection/utils/constants.ts
import { 
  PAGINATION,
  DATE_FORMATS
  // Импортируем только те константы, которые действительно экспортируются из глобального файла
} from '@/utils/constants';

import type { 
  StatusSettingsType, 
  ClientStats, 
  AutoCalculationRequirements 
} from '../types/types';

// Статусы клиентов
export const CLIENT_STATUSES = {
  COLD: 'cold',
  RARE: 'rare',
  NEW: 'new',
  REGULAR: 'regular',
  LOYAL: 'loyal',
  LOST: 'lost',
} as const;

// Ре-экспорт доступных глобальных констант
export {
  PAGINATION,
  DATE_FORMATS
};

// Задержки
export const DELAYS = {
  SEARCH_DEBOUNCE: 300,
  CART_REMINDER: 30 * 60 * 1000, // 30 минут в миллисекундах
} as const;

// Изменения статуса
export const STATUS_CHANGES = {
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
} as const;

// Каналы связи
export const COMMUNICATION_CHANNELS = {
  WHATSAPP: 'WhatsApp',
  TELEGRAM: 'Telegram',
  INSTAGRAM: 'Instagram',
  MESSENGER: 'Messenger',
} as const;

// Настройки экспорта
export const EXPORT_SETTINGS = {
  FILENAME_PREFIX: 'clients_export_',
  ENCODING: 'utf-8',
  DELIMITER: ',',
} as const;

// Валидация
export const VALIDATION = {
  PHONE_REGEX: /^\+7 \d{3} \d{3} \d{2} \d{2}$/,
  MAX_DISCOUNT: 99,
  MIN_DISCOUNT: 0,
} as const;

// Сообщения об ошибках - ключи переводов
export const ERROR_MESSAGES = {
  INVALID_PHONE: 'errors.invalid_phone',
  INVALID_DISCOUNT: 'errors.invalid_discount',
  INVALID_DATE: 'errors.invalid_date',
} as const;

// Подсказки - ключи переводов
export const TOOLTIPS = {
  AUTO_CALCULATION: 'clients.tooltips.auto_calculation',
  MANUAL_SETTINGS: 'clients.tooltips.manual_settings',
  EXPORT: 'clients.tooltips.export',
} as const;

// Заголовки таблицы - ключи переводов
export const TABLE_HEADERS = {
  base: [
    { key: 'id', title: 'clients.table.id' },
    { key: 'name', title: 'clients.table.name' },
    { key: 'phone', title: 'clients.table.phone' },
    { key: 'ordersCount', title: 'clients.table.orders_count' },
    { key: 'totalAmount', title: 'clients.table.total_amount' },
    { key: 'lastOrder', title: 'clients.table.last_order' },
    { key: 'status', title: 'clients.table.status' },
  ],
  extended: [
    { key: 'email', title: 'clients.table.email' },
    { key: 'noMailings', title: 'clients.table.mailings' },
    { key: 'abandonedCarts', title: 'clients.table.abandoned_carts' },
    { key: 'discount', title: 'clients.table.discount' },
    { key: 'created', title: 'clients.table.created' },
  ],
} as const;

// Настройки статусов по умолчанию
export const DEFAULT_SETTINGS: StatusSettingsType = { 
  id: 'default',
  ordersX: 2, 
  ordersZ: 5, 
  intervalA: 21, 
  intervalB: 11, 
  daysC: 51 
};

// Статистика клиентов по умолчанию
export const DEFAULT_STATS: ClientStats = {
  cold: 0,
  new: 0,
  rare: 0,
  regular: 0,
  loyal: 0,
  lost: 0
};

// Требования для автоматического расчета статусов
export const DEFAULT_AUTO_CALCULATION_REQUIREMENTS: AutoCalculationRequirements = {
  MIN_REGULAR_CLIENTS: 20,
  MIN_LOYAL_CLIENTS: 5
};